import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { useAuth } from "@/contexts/AuthContext";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bg-white">
      <div className="hidden md:flex flex-1 bg-gradient-to-br from-[#7C3AED] via-[#6D28D9] to-[#4C1D95] p-12 flex-col justify-between">
        <Logo size={32} textColor="text-white" iconColor="#FFFFFF" />
        <div className="text-white max-w-md">
          <h2 className="text-4xl font-bold mb-4 leading-tight">The marketing engine that runs itself.</h2>
          <p className="text-purple-100 text-lg">From a single topic to platform-ready videos, emails, and ads — Optimus Prime automates the heavy lifting.</p>
        </div>
        <p className="text-purple-200 text-sm">© 2026 Optimus Prime</p>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="md:hidden mb-8"><Logo size={28} /></div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome back</h1>
          <p className="text-gray-500 mb-8">Sign in to keep growing.</p>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="op-input mb-4" placeholder="you@brand.com" data-testid="login-email-input" />
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="op-input mb-6" placeholder="••••••••" data-testid="login-password-input" />
          <button type="submit" disabled={loading} className="op-btn-primary w-full justify-center" data-testid="login-submit-btn">
            {loading ? "Signing in..." : "Sign in →"}
          </button>
          <p className="mt-6 text-sm text-gray-600 text-center">
            New here? <Link to="/signup" className="text-[#7C3AED] font-semibold" data-testid="login-signup-link">Create an account</Link>
          </p>
        </form>
      </div>
    </div>
  );
};
export default Login;
